<template>
  <b-card
    v-if="dataList"
    no-body
  >
    <b-card-header>
      <b-card-title>Açık Servis Formları</b-card-title>
      <b-button
        variant="flat-primary"
        size="sm"
        pill
        to="/services"
      >
        Tüm Formları Görüntüle
      </b-button>
    </b-card-header>
    <b-table
      :items="dataList"
      responsive
      :fields="fields"
      class="mb-0"
    >
      <template #cell(customer_company)="data">
        <b-link
          :to="'/services/view/' + data.item.id"
          class="font-weight-bold text-body"
        >
          <div class="font-weight-bold">
            {{ data.item.customer_company }}
          </div>
          <div class="font-small-3 text-primary">
            {{ data.item.customer_name }}
          </div>
          <hr>
          <div class="d-flex align-items-center">
            <div class="font-small-3 text-primary mr-1 border-right pr-1">
              <strong>Başlangıç:</strong>
              {{ data.item.sdate? moment(data.item.sdate).format('DD.MM.YYYY') : '-' }}
            </div>
            <div class="font-small-3 text-primary pr-1 mr-1 border-right">
              <strong>Teslim:</strong> {{ data.item.edate? moment(data.item.edate).format('DD.MM.YYYY') : '-' }}
            </div>
            <div
              v-if="data.item.totalDurations"
              class="font-small-3 text-danger"
            >
              <strong>Toplam Mesai:</strong>
              {{ data.item.totalDurations.formatted_duration }}
            </div>
          </div>
        </b-link>
      </template>
      <template #cell(service_type)="data">
        <b-badge
          :variant="data.item.service_type_variant"
          class="w-100"
        >
          {{ data.item.service_type }}
        </b-badge>
      </template>
      <template #cell(service_status)="data">
        <b-badge
          :variant="data.item.service_status_variant"
          class="w-100"
        >
          {{ data.item.service_status }}
        </b-badge>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BBadge, BButton, BPagination, BCardFooter, BCardHeader, BCardTitle, BLink,
} from 'bootstrap-vue'

const tableName = 'services'
export default {
  components: {
    BCardFooter,
    BPagination,
    BCard,
    BTable,
    BBadge,
    BButton,
    BCardHeader,
    BCardTitle,
    BLink,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: 'customer_company',
          label: 'MÜŞTERİ',
        },
        {
          key: 'service_type',
          label: 'HİZMET ŞEKLİ',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.sdate AS sdate`,
          `${tableName}.edate AS edate`,
          'customers.company AS customer_company',
          'customers.name AS customer_name',
          'service_types.title AS service_type',
          'service_types.variant AS service_type_variant',
          'service_statuses.title AS service_status',
          'service_statuses.variant AS service_status_variant',
        ],
        where: {
          'services.id_service_statuses <=': 2,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
        totalDurations: true,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['services/dataList']
    },
    dataCounts() {
      return this.$store.getters['services/dataCounts']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * 10
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('services/getDataList', this.dataQuery)
    },
  },
}
</script>
